import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { FiCheck } from "react-icons/fi";
import {useTranslation} from "react-i18next";

const AboutTabs = () => {
    const {t} = useTranslation();

    let
        tab1 = t('about.tabs.styleTab.title'),
        tab2 = t('about.tabs.missionTab.title'),
        tab3 = t('about.tabs.propositionTab.title');
    let styleTabItems = [
        t('about.tabs.styleTab.result'),
        t('about.tabs.styleTab.reliability'),
        t('about.tabs.styleTab.efficiency'),
    ];
    let missionTabItems = [
        t('about.tabs.missionTab.first'),
        t('about.tabs.missionTab.second'),
        t('about.tabs.missionTab.third'),
    ];
    return (
        <div>
            {/* Start Tabs Area */}
            <div className="tabs-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <Tabs>
                                <TabList  className="tab-style--1">
                                    <Tab>{tab1}</Tab>
                                    <Tab>{tab2}</Tab>
                                    <Tab>{tab3}</Tab>
                                </TabList>

                                <TabPanel>
                                    <div className="single-tab-content">
                                        <p>{t('about.tabs.styleTab.description')}</p>

                                        <div className="mt--30">
                                            <h4>{t('about.tabs.styleTab.values')}</h4>
                                            <ul className="list-style--1">
                                                {styleTabItems.map((name, index) => {
                                                    return <li key={ index }><FiCheck /> {name}</li>;
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                </TabPanel>

                                <TabPanel>
                                    <div className="single-tab-content">
                                        <p>{t('about.tabs.missionTab.description')}</p>
                                        <div className="mt--30">
                                            <h4>{t('about.tabs.missionTab.values')}</h4>
                                            <ul className="list-style--1">
                                                {missionTabItems.map((name, index) => {
                                                    return <li key={ index }><FiCheck /> {name}</li>;
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                </TabPanel>

                                <TabPanel>
                                    <div className="single-tab-content">
                                        <p>{t("about.tabs.propositionTab.first")}</p>
                                        <p>{t("about.tabs.propositionTab.second")}</p>
                                        <p>{t("about.tabs.propositionTab.third")}</p>
                                        <p>{t("about.tabs.propositionTab.fourth")}</p>
                                    </div>
                                </TabPanel>

                            </Tabs>
                        </div>
                    </div>
                </div>
            </div>
            {/* End Tabs Area */}
        </div>
    );
}
export default AboutTabs;
